import RanDBUploadModalTableNewSites from './ran_db_upload_modal_table';
import RanDBUploadModalTableUpdatedSites from './ran_db_upload_modal_table_updated_sites.component';
import RanDBUploadModalTableDeletedSites from './ran_db_upload_modal_table_deleted_sites.component';
import NextAndBackButtonForUpload from './next_and_back_button_for_upload.component';
import NavBarForUpload from './nav_bar_for_upload.component';
import FileReviewUploadtopHeading from './file_review_upload_top_heading.component';
import { useAtomValue } from 'jotai';
import { currentUploadStep } from '../../common/atom/atoms';
import { Alert } from '@mui/material';

export default function RanDbUploadModalHeader({ onUploadComplete }) {
  const currentStep = useAtomValue(currentUploadStep);
  const stepHint =
    currentStep === 0
      ? 'Select site for add new sites'
      : currentStep === 1
        ? 'Select for update site'
        : currentStep === 2
          ? 'These sites are available in the database but missing from the file. Please select the sites to be removed from the database.'
          : '';
  const renderStepComponent = () => {
    switch (currentStep) {
      case 0:
        return <RanDBUploadModalTableNewSites />;
      case 1:
        return <RanDBUploadModalTableUpdatedSites />;
      case 2:
        return <RanDBUploadModalTableDeletedSites />;
      default:
        return null;
    }
  };
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        padding: 20,
        background: 'white',
        borderRadius: 12,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 24,
        display: 'inline-flex',
      }}
    >
      <FileReviewUploadtopHeading />
      <NavBarForUpload />
      {stepHint ? (
        <Alert
          severity="info"
          variant="outlined"
          sx={{
            width: '100%',
            borderRadius: 2,
            borderColor: '#84caff',
            backgroundColor: '#f0f9ff',
            color: '#0b4a6f',
            fontFamily: 'Inter',
            '& .MuiAlert-icon': { color: '#0284c7' },
            '& .MuiAlert-message': { fontWeight: 600 },
          }}
        >
          {stepHint}
        </Alert>
      ) : null}
      {renderStepComponent()}
      <NextAndBackButtonForUpload onUploadComplete={onUploadComplete} />
    </div>
  );
}
